// extracted by mini-css-extract-plugin
module.exports = {"item":"styles__item","checked":"styles__checked","label":"styles__label","container":"styles__container"};